export enum SegmentEventProductivityEnum {
  'page_view' = 'People: Productivity Module - Page View Page',
  'know_more_button' = 'People: Productivity Module - know more button',
  'active_now_button' = 'People: Productivity Module - active now button',
  'schedule_active_button' = 'People: Productivity Module - schedule activation button',
  'request_active_button' = 'People: Productivity Module - request activation button'
}

